import React, { useMemo } from 'react';
import styled from 'styled-components';
import PlayButtonImage from '../../assets/play.svg';

import { ColContainer, Text } from '../atoms';
import { ISession } from '../../entity/type';

const SessionContainer = styled.a`
  width: 100%;
  padding: 0px 20px 32px;

  @media (min-width: 800px) {
    width: calc(50%);
  }
`;

const PlayBtn = styled.div`
  width: 50px;
  height: 50px;

  background-image: url(${PlayButtonImage});
  background-repeat: no-repeat;
  background-position: center;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  opacity: 0.95;

  pointer-events: none;

  transition-property: opacity;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
`;

type PlayContaienrProps = {
  url?: string | null;
};

const Dim = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  pointer-events: none;

  transition-property: background-color;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
`

const PlayContainer = styled(ColContainer)`
  justify-content: center;
  align-items: center;

  width: 100%;
  padding-top: 56.25%;

  position: relative;

  background-color: rgba(0, 0, 0, 1);

  border-radius: 12px;

  background-image: url(${(props: PlayContaienrProps) => (props.url ? props.url : '')});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  cursor: pointer;

  &:hover ${Dim} {
    background-color: rgba(0, 0, 0, 0);
  }

  &:hover ${PlayBtn} {
    opacity: 0;
  }
`;

const TextContainer = styled(ColContainer)`
  width: 100%;
  padding: 20px 8px 4px;
  align-items: flex-start;

  & * {
    text-align: start;
  }
`;

const SpeakerName = styled.div`
  font-weight: 600;
`

const SpeakerJob = styled.div`
  margin-left: 8px;
  color: #CCCCCC;
`

function Session({
  session,
  sessionId,
}: {
  session: ISession;
  sessionId: string;
}) {
  const speakerNames = useMemo(() => session.speakers.map(speaker => speaker.name).join(', '), [session.speakers])

  const spekerJob = useMemo(() => session.speakers[0].job, [session.speakers])

  return (
    <SessionContainer href={`/2021/sessions/${sessionId}`}>
      <PlayContainer url={session.thumbnailImage} >
        <Dim />
        <PlayBtn />
      </PlayContainer>
      <TextContainer>
        <Text weight='600' size='20px' mb='4px' color='white' style={{ textAlign: 'left', wordBreak: 'keep-all' }}>
          {session.title}
        </Text>
      </TextContainer>
      <Text
          w='100%'
          weight='400'
          size='16px'
          color='white'
          style={{ justifyContent: 'flex-start', paddingLeft: 8 }}
        >
          <SpeakerName>
            {`🎙 ${speakerNames}`}
          </SpeakerName>
          <SpeakerJob>
            {spekerJob}
          </SpeakerJob>
        </Text>
    </SessionContainer>
  );
}

export default Session;
